import {AxiosResponse} from 'axios';
import {ElMessage} from 'element-plus';

import {router} from '@/router/router';

let redirecting = false;

const vCodeErrorHandle = (res: AxiosResponse) => {
  const vData = res.data;
  if (!vData) {
    return;
  }
  if (vData.code === 401) {
    if (!redirecting && router.currentRoute.value.path !== '/login') {
      redirecting = true;
      ElMessage.error(vData.msg || '登录已过期');
      router.push({ path: '/login' });
      setTimeout(() => { redirecting = false }, 2000);
    }
    return;
  }
};

export {
  vCodeErrorHandle
};
